import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "@/core/components/Header";
import Footer from "@/core/components/Footer";
import { UIProvider } from "@/core/components/context/UIContext";

// Eager load only the homepage
import HomePage from "@/core/Pages/HomePage";

// Lazy load all other pages
const ProductsPage = lazy(() => import("@/core/Pages/ProductsPage"));
const AboutPage = lazy(() => import("@/core/Pages/AboutPage"));
const ContactPage = lazy(() => import("@/core/Pages/ContactPage"));
const LocationsPage = lazy(() => import("@/core/Pages/LocationsPage"));

// Optimized loading component
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="w-12 h-12 border-4 border-cannabis-green-500 border-t-transparent rounded-full animate-spin"></div>
  </div>
);

function App() {
  return (
    <UIProvider>
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-grow">
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/locations" element={<LocationsPage />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </div>
    </UIProvider>
  );
}

export default App;
